export default __webpack_public_path__ + "static/media/menu-settings.036705cf.svg";